// CrewMagic dashboard root — composes the canvas frontpage:
// paper background + header (logo/picker/search/theme/avatar) +
// notif strip + canvas (with nodes/edges/legend/zoom/addzone) +
// the click-into agent modal (mounted alongside; conditional render).

import { Header } from "./Shell/Header"
import { NotifStrip } from "./Approvals/NotifStrip"
import { Canvas } from "./Canvas/Canvas"
import { AgentModal } from "./AgentModal/AgentModal"

export function App() {
  return (
    <>
      <div className="cm-paper-bg" />
      <div className="cm-app">
        <Header />
        <NotifStrip />
        <Canvas />
      </div>
      <AgentModal />
    </>
  )
}
